import { YoutubeBlock } from "@/api/generated-api";
import { FC } from "react";
import S from "./index.module.scss";

interface ITechnologyYoutube {
  data: YoutubeBlock;
}

const TechnologyYoutube: FC<ITechnologyYoutube> = ({ data }) => {
  const { url } = data;

  return (
    <iframe
      className={S.video}
      title="video"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      src={url}
    />
  );
};

export default TechnologyYoutube;
